export function morphdomPreserveAttributes(element, attributes) {
  const formattedAttributes = attributes.join(" ")

  element.dataset.turboMorphPreserveAttributes = formattedAttributes
}

export function morphdomCopyPreservedAttributes(fromElement, toElement) {
  const dataset = fromElement.dataset
  const preserveAttributesAttributeName = "turboMorphPreserveAttributes"

  if (!dataset.hasOwnProperty(preserveAttributesAttributeName)) {
    return
  }

  const delimitedAttributes = dataset[preserveAttributesAttributeName]
  let attributes = delimitedAttributes.split(" ")
  attributes.push("data-turbo-morph-preserve-attributes")

  for (let attribute of attributes) {
    const hasAttribute = fromElement.hasAttribute(attribute)

    if (hasAttribute) {
      const value = fromElement.getAttribute(attribute)
      toElement.setAttribute(attribute, value)
    } else {
      toElement.removeAttribute(attribute)
    }
  }
}
